module.exports = __webpack_public_path__ + "img/hr-tree-03-c-trunk.2982973f.png";